import { Component, Input, ViewChild } from '@angular/core';

import { Menu } from 'primeng/menu';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'lib-dropdown',
  imports: [Menu],
  templateUrl: './dropdown.component.html',
  styleUrl: './dropdown.component.css',
})
export class DropdownComponent {
  @Input() items: MenuItem[] = [];
  @ViewChild('menu') menuRef!: Menu;

  toggle(event: MouseEvent) {
    if (this.items.length > 0) {
      this.menuRef.toggle(event);
    }
  }
}
